import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class CfgOneStepService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  createCfgOneStep = async (session_id, record) => {
    try {
      return await this.HttpService.postJson(
        this.constants.cfgOneStepServicesURLs.postCfgOneStep,
        record,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getCfgOneStep = async (session_id, accountId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgOneStepServicesURLs.getAllCfgOneStep + `${accountId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getCfgOneStepByIBG = async (session_id, accountId, groupId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgOneStepServicesURLs.getAllCfgOneStep +
          `${accountId}` +
          "/" +
          `${groupId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getAllCfgOneStep = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgOneStepServicesURLs.getAllCfgOneStep,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  editCfgOneStep = async (session_id, record) => {
    try {
      return await this.HttpService.putJson(
        this.constants.cfgOneStepServicesURLs.editCfgOneStep,
        record,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
